<div class="prospect-registration-container">
  <div class="prospect-card">
    
    <!-- Cabecera del Registro -->
    <div class="prospect-header">
      <h2 class="prospect-title">{{ titulo }}</h2>
      <p class="prospect-subtitle">
        Únase a nuestra plataforma. Complete los siguientes pasos para registrar su postulación.
      </p>
    </div>

    <!-- Stepper de Pasos -->
    <p-stepper [(activeStep)]="active" [linear]="true">
      
      <!-- PASO 1: Datos del Conductor -->
      <p-stepperPanel header="{{ step1_titulo }}">
        <ng-template pTemplate="content">
          <form (ngSubmit)="next()" [formGroup]="formConductor" class="mt-4">
            
            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-user"></i> Información Personal y de Contacto
              </h3>
              
              <div class="row">
                <!-- Nombre -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nombre*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-user"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_name"
                      placeholder="Ingrese sus nombres"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_name'].hasError('required') &&
                      formConductor.controls['dri_name'].touched
                    "
                  >
                    El nombre es requerido.
                  </span>
                </div>

                <!-- Apellido -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Apellido*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-user"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_last_name"
                      placeholder="Ingrese sus apellidos"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_last_name'].hasError('required') &&
                      formConductor.controls['dri_last_name'].touched
                    "
                  >
                    El apellido es requerido.
                  </span>
                </div>
              </div>

              <div class="row">
                <!-- Teléfono -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Teléfono*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-phone"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="dri_phone"
                      placeholder="Ej: 0987654321"
                    />
                  </p-iconField>
                  <span class="form-help-text">
                    Este campo es requerido por nuestro sistema. Tu número de teléfono se utilizará como identificador de acceso (nombre de usuario) para ingresar a tu cuenta de conductor y para garantizar una comunicación fluida sobre el estado de tu postulación.
                  </span>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_phone'].hasError('required') &&
                      formConductor.controls['dri_phone'].touched
                    "
                  >
                    El teléfono es requerido.
                  </span>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_phone'].hasError('pattern') &&
                      formConductor.controls['dri_phone'].touched
                    "
                  >
                    El teléfono solo acepta números.
                  </span>
                </div>
              </div>
            </div>

            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-lock"></i> Credenciales de Seguridad
              </h3>
              
              <div class="row">
                <!-- Password -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Contraseña*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-key"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="password"
                      pInputText
                      formControlName="dri_password"
                      placeholder="Mínimo 6 caracteres"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formConductor.controls['dri_password'].hasError('required') &&
                      formConductor.controls['dri_password'].touched
                    "
                  >
                    La contraseña es requerida.
                  </span>
                </div>
              </div>

              <!-- Términos y Condiciones -->
              <div class="row mt-2">
                <div class="col-12 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="dri_term_conditions"
                    [binary]="true"
                    inputId="term_cond"
                  />
                  <label for="term_cond" class="form-label-edit m-0 cursor-pointer">
                    Acepto los Términos y Condiciones de uso*
                  </label>
                </div>
              </div>
            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-end pt-3">
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                [disabled]="formConductor.invalid"
                [rounded]="true"
                severity="primary"
              />
            </div>

          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 2: Selección de Compañía -->
      <p-stepperPanel header="{{ step2_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-briefcase"></i> Selección de Compañía
              </h3>
              <p class="text-secondary small mb-4">
                Por favor seleccione la compañía de transporte a la que desea afiliarse.
              </p>

              <div class="table-responsive">
                <p-table
                  [value]="ltsCompany"
                  [(selection)]="selectCompany"
                  dataKey="com_id"
                  [tableStyle]="{ 'min-width': '40rem' }"
                  responsiveLayout="scroll"
                  [paginator]="true"
                  [rows]="5"
                  [rowsPerPageOptions]="[5, 10, 15]"
                  [showCurrentPageReport]="true"
                  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Compañías"
                  styleClass="p-datatable-striped p-datatable-sm"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th id="tbcheck" style="width: 4rem"></th>
                      <th id="tbname">Nombre</th>
                      <th id="tbphone">Teléfono</th>
                      <th id="tbaddress">Dirección</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-company>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-center">
                          <p-radioButton
                            [inputId]="company.com_id"
                            name="company"
                            [value]="company"
                            [(ngModel)]="selectCompany"
                          />
                        </div>
                      </td>
                      <td class="font-semibold">{{ company.com_name }}</td>
                      <td>{{ company.com_phone }}</td>
                      <td>{{ company.com_address }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-between pt-3">
              <p-button
                label="Atrás"
                icon="pi pi-arrow-left"
                [outlined]="true"
                severity="secondary"
                [rounded]="true"
                (onClick)="back()"
              />
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                [rounded]="true"
                severity="primary"
                [disabled]="!selectCompany"
                (onClick)="next()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 3: Datos del Vehículo -->
      <p-stepperPanel header="{{ step3_titulo }}">
        <ng-template pTemplate="content">
          <form (ngSubmit)="next()" [formGroup]="formVehiculo" class="mt-4">

            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-info-circle"></i> Especificaciones Básicas
              </h3>

              <div class="row">
                <!-- Placa -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Placa*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-id-card"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_plate"
                      placeholder="Ej: ABC-1234"
                    />
                  </p-iconField>
                  <span
                    class="text-danger labelError"
                    *ngIf="
                      formVehiculo.controls['veh_plate'].hasError('required') &&
                      formVehiculo.controls['veh_plate'].touched
                    "
                  >
                    La placa es requerida.
                  </span>
                </div>

                <!-- Nro. Registro -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Nro. Registro*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-file"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_num_registration"
                      placeholder="Ingrese el nro de registro"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_num_registration'].hasError('required') && formVehiculo.controls['veh_num_registration'].touched) {
                    <span class="text-danger labelError">El número de registro es requerido.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Marca -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Marca*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-tag"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_brand"
                      placeholder="Ej: Chevrolet, Hyundai, Renault"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_brand'].hasError('required') && formVehiculo.controls['veh_brand'].touched) {
                    <span class="text-danger labelError">La marca es requerida.</span>
                  }
                </div>

                <!-- Modelo -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Modelo*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-car"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_model"
                      placeholder="Ej: Logan, Accent, etc."
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_model'].hasError('required') && formVehiculo.controls['veh_model'].touched) {
                    <span class="text-danger labelError">El modelo es requerido.</span>
                  }
                </div>
              </div>
            </div>

            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-cog"></i> Detalles Técnicos
              </h3>

              <div class="row">
                <!-- Año -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Año*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-calendar"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_anio"
                      placeholder="Ej: 2023"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_anio'].hasError('required') && formVehiculo.controls['veh_anio'].touched) {
                    <span class="text-danger labelError">El año es requerido.</span>
                  }
                </div>

                <!-- Color -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Color*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-palette"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_color"
                      placeholder="Ej: Amarillo, Blanco"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_color'].hasError('required') && formVehiculo.controls['veh_color'].touched) {
                    <span class="text-danger labelError">El color es requerido.</span>
                  }
                </div>
              </div>

              <div class="row">
                <!-- Cantidad de Ocupantes -->
                <div class="col-12 col-md-6 mb-3">
                  <label class="form-label-edit">Cantidad de Ocupantes*</label>
                  <p-iconField iconPosition="left" class="w-100">
                    <p-inputIcon><i class="pi pi-users"></i></p-inputIcon>
                    <input
                      class="largeInput"
                      type="text"
                      pInputText
                      formControlName="veh_quantity_person"
                      placeholder="Ej: 4"
                    />
                  </p-iconField>
                  @if (formVehiculo.controls['veh_quantity_person'].hasError('required') && formVehiculo.controls['veh_quantity_person'].touched) {
                    <span class="text-danger labelError">La cantidad de ocupantes es requerida.</span>
                  }
                </div>
              </div>
            </div>

            <div class="form-section-card">
              <h3 class="form-section-title">
                <i class="pi pi-shield"></i> Estado Legal y Revisiones
              </h3>
              <div class="row">
                <!-- Inspección -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_inspection"
                    [binary]="true"
                    inputId="veh_inspection"
                  />
                  <label for="veh_inspection" class="form-label-edit m-0 cursor-pointer">
                    Inspección Vehicular Aprobada*
                  </label>
                </div>

                <!-- Seguro -->
                <div class="col-12 col-md-6 mb-3 d-flex align-items-center gap-2">
                  <p-checkbox
                    formControlName="veh_secure"
                    [binary]="true"
                    inputId="veh_secure"
                  />
                  <label for="veh_secure" class="form-label-edit m-0 cursor-pointer">
                    Seguro Vigente *
                  </label>
                </div>
              </div>
            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-between pt-3">
              <p-button
                label="Atrás"
                icon="pi pi-arrow-left"
                [outlined]="true"
                severity="secondary"
                [rounded]="true"
                (onClick)="back()"
              />
              <p-button
                label="Continuar"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                [disabled]="formVehiculo.invalid"
                [rounded]="true"
                severity="primary"
              />
            </div>
          </form>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 4: Carga de Documentación -->
      <p-stepperPanel header="{{ step4_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="row">
              <!-- Columna Carga -->
              <div class="col-12 col-md-5 mb-4 mb-md-0">
                <div class="form-section-card h-100">
                  <h3 class="form-section-title">
                    <i class="pi pi-cloud-upload"></i> Subir Foto de Perfil
                  </h3>
                  
                  <div class="logo-upload-box text-center">
                    <p-fileUpload
                      #fileUpload
                      mode="basic"
                      chooseLabel="Buscar Foto"
                      chooseIcon="pi pi-plus"
                      [showUploadButton]="false"
                      [showCancelButton]="false"
                      maxFileSize="7340032"
                      (onSelect)="onUploadAuto($event.files, fileUpload)"
                      accept="image/png,image/jpeg"
                      [multiple]="false"
                      styleClass="p-button-primary p-button-outlined w-100"
                    >
                    </p-fileUpload>
                    <p class="text-secondary small mt-3 mb-0">
                      Formatos soportados: JPG, PNG. Tamaño máx: 7MB.
                    </p>
                  </div>

                  <div class="alert alert-info mt-4 py-2 px-3 border-0 rounded-3 small">
                    <i class="pi pi-info-circle me-1"></i>
                    <strong>Nota:</strong> Es indispensable subir una foto de perfil clara para continuar.
                  </div>
                </div>
              </div>

              <!-- Columna Previsualización -->
              <div class="col-12 col-md-7">
                <div class="form-section-card h-100">
                  <h3 class="form-section-title">
                    <i class="pi pi-image"></i> Documento Adjuntado
                  </h3>

                  @if (ltsDocument.length === 0) {
                    <div class="text-center py-5">
                      <i class="pi pi-camera text-muted mb-3" style="font-size: 3rem;"></i>
                      <p class="text-muted">Ninguna foto de perfil cargada. Use el panel de la izquierda.</p>
                    </div>
                  } @else {
                    <div class="table-responsive">
                      <p-table [value]="ltsDocument" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                          <tr>
                            <th id="tbimage">Vista previa</th>
                            <th id="tbnamedoc">Archivo</th>
                            <th id="tbtypedoc">Tipo</th>
                            <th id="tbactiondoc" style="width: 4rem"></th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-doc let-index="rowIndex">
                          <tr>
                            <td>
                              @if (doc.filstring) {
                                <p-image
                                  [src]="doc.filstring"
                                  alt="Foto de perfil"
                                  width="50"
                                  height="50"
                                  imageClass="rounded border shadow-sm"
                                  [style]="{ 'object-fit': 'cover' }"
                                />
                              }
                            </td>
                            <td class="text-truncate font-semibold" style="max-width: 140px;">
                              {{ doc.file.name }}
                            </td>
                            <td>
                              <span class="badge bg-primary text-white">
                                {{ doc.typeDocument.typ_name }}
                              </span>
                            </td>
                            <td>
                              <p-button
                                icon="pi pi-trash"
                                [rounded]="true"
                                [text]="true"
                                severity="danger"
                                (onClick)="remeveFile(index)"
                              ></p-button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-between pt-4">
              <p-button
                label="Atrás"
                icon="pi pi-arrow-left"
                [outlined]="true"
                severity="secondary"
                [rounded]="true"
                (onClick)="back()"
              />
              <p-button
                label="Enviar Registro"
                icon="pi pi-check"
                iconPos="right"
                [rounded]="true"
                severity="primary"
                [disabled]="ltsDocument.length === 0"
                [loading]="loading"
                (onClick)="crearDriver()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 5: Documentos del Vehículo (se omite si la placa quedó en conflicto) -->
      <p-stepperPanel header="{{ step5_titulo }}">
        <ng-template pTemplate="content">
          <div class="mt-4">
            <div class="row">
              <!-- Columna Carga -->
              <div class="col-12 col-md-5 mb-4 mb-md-0">
                <div class="form-section-card h-100">
                  <h3 class="form-section-title">
                    <i class="pi pi-cloud-upload"></i> Subir Documentos del Vehículo
                  </h3>

                  <div class="mb-3">
                    <label class="form-label-edit">Tipo de Documento</label>
                    <p-dropdown
                      [options]="ltsTypeDocumentVehicle"
                      [(ngModel)]="selectedTypeDocumentVehicle"
                      optionLabel="typ_name"
                      placeholder="Seleccionar tipo"
                      styleClass="largeInput"
                      [appendTo]="'body'"
                    />
                  </div>

                  <div class="logo-upload-box text-center">
                    <p-fileUpload
                      #fileUploadVehicle
                      mode="basic"
                      chooseLabel="Adjuntar"
                      chooseIcon="pi pi-plus"
                      [showUploadButton]="false"
                      [showCancelButton]="false"
                      maxFileSize="7340032"
                      (onSelect)="onUploadAutoVehicle($event.files, fileUploadVehicle)"
                      accept="image/png,image/jpeg,application/pdf"
                      [multiple]="false"
                      styleClass="p-button-primary p-button-outlined w-100"
                    >
                    </p-fileUpload>
                    <p class="text-secondary small mt-3 mb-0">
                      Imágenes o PDFs hasta 7MB.
                    </p>
                  </div>

                  <div class="alert alert-info mt-4 py-2 px-3 border-0 rounded-3 small">
                    <i class="pi pi-info-circle me-1"></i>
                    Los documentos del vehículo son opcionales acá; también se pueden completar después.
                  </div>
                </div>
              </div>

              <!-- Columna Previsualización -->
              <div class="col-12 col-md-7">
                <div class="form-section-card h-100">
                  <h3 class="form-section-title">
                    <i class="pi pi-image"></i> Documentos Adjuntados
                  </h3>

                  @if (ltsDocumentVehicle.length === 0) {
                    <div class="text-center py-5">
                      <i class="pi pi-camera text-muted mb-3" style="font-size: 3rem;"></i>
                      <p class="text-muted">Ningún documento cargado todavía. Use el panel de la izquierda.</p>
                    </div>
                  } @else {
                    <div class="table-responsive">
                      <p-table [value]="ltsDocumentVehicle" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                          <tr>
                            <th id="tbimageveh">Vista previa</th>
                            <th id="tbnamedocveh">Archivo</th>
                            <th id="tbtypedocveh">Tipo</th>
                            <th id="tbactiondocveh" style="width: 4rem"></th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-doc let-index="rowIndex">
                          <tr>
                            <td>
                              @if (doc.filstring) {
                                <p-image
                                  [src]="doc.filstring"
                                  alt="Documento"
                                  width="50"
                                  height="50"
                                  imageClass="rounded border shadow-sm"
                                  [style]="{ 'object-fit': 'cover' }"
                                />
                              }
                            </td>
                            <td class="text-truncate font-semibold" style="max-width: 140px;">
                              {{ doc.file.name }}
                            </td>
                            <td>
                              <span class="badge bg-primary text-white">
                                {{ doc.typeDocument.typ_name }}
                              </span>
                            </td>
                            <td>
                              <p-button
                                icon="pi pi-trash"
                                [rounded]="true"
                                [text]="true"
                                severity="danger"
                                (onClick)="remeveFileVehicle(index)"
                              ></p-button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  }
                </div>
              </div>
            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-end pt-4">
              <p-button
                label="Finalizar Registro"
                icon="pi pi-check"
                iconPos="right"
                [rounded]="true"
                severity="primary"
                (onClick)="guardarDocumentosVehiculo()"
              />
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- PASO 6: Finalizado -->
      <p-stepperPanel header="{{ step6_titulo }}">
        <ng-template pTemplate="content">
          <div class="success-container mt-4">
            <div class="success-icon-wrapper">
              <i class="pi pi-check"></i>
            </div>

            @if (vehicleConflict) {
              <h3 class="success-title">Registro Enviado — Pendiente por Conflicto de Placa</h3>
              <p class="success-subtitle">
                Tu registro fue recibido, pero la placa del vehículo que ingresaste ya está asignada a otro conductor. Un administrador se comunicará contigo para que te registres nuevamente con otra placa.
              </p>
            } @else {
              <h3 class="success-title">¡Registro Enviado Correctamente!</h3>
              <p class="success-subtitle">
                Su solicitud de conductor y su vehículo han sido ingresados en el sistema. Nuestro equipo administrativo revisará sus datos y documentos adjuntos lo antes posible.
              </p>
            }
            @if (resultMessage) {
              <div class="alert" [ngClass]="vehicleConflict ? 'alert-warning' : 'alert-success'" style="max-width: 560px; margin: 0 auto 1.5rem;">
                <i class="pi pi-info-circle me-1"></i>
                <span class="small">{{ resultMessage }}</span>
              </div>
            }

            <div class="alert alert-success d-inline-flex align-items-center gap-2 px-4 py-3 rounded-3 max-w-500 mx-auto">
              <i class="pi pi-info-circle fs-5"></i>
              <span class="text-start small">
                Pronto recibirá una notificación por correo o vía telefónica con la respuesta a su registro de postulación.
              </span>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

    </p-stepper>
  </div>
</div>
